import React from "react";

import { Avatar } from "@/components/atoms/Avatar/Avatar";

import { cn } from "@/utils/cn";

import { TMember } from "@/types";

export interface IMemberAvatarProps {
	member: Pick<TMember, "firstName" | "lastName" | "avatar">;
	className?: string;
}

export const initialsOf = (
	member: Pick<TMember, "firstName" | "lastName">
): string =>
	`${member.firstName.trim().charAt(0)}${member.lastName.trim().charAt(0)}`.toUpperCase();

/** A member's picture, their initials when they have none. */
export const MemberAvatar: React.FC<IMemberAvatarProps> = ({
	member,
	className,
}) => (
	<div className={cn(["h-8 w-8 shrink-0", className])}>
		<Avatar
			url={member.avatar}
			alt={`${member.firstName} ${member.lastName}`}
			className="bg-primary-100 text-primary-800 flex items-center justify-center text-xs font-medium"
		>
			{!member.avatar && initialsOf(member)}
		</Avatar>
	</div>
);
